import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Result, Guard, UniqueEntityID } from '@digibricks/core';
import { Questions } from './questions';
export var SectionSummary = /*#__PURE__*/function (_Entity) {
  _inherits(SectionSummary, _Entity);

  var _super = _createSuper(SectionSummary);

  function SectionSummary() {
    _classCallCheck(this, SectionSummary);

    return _super.apply(this, arguments);
  }

  _createClass(SectionSummary, [{
    key: "formId",
    get: function get() {
      return this.props.formId;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "totalScore",
    get: function get() {
      return this.props.totalScore;
    }
  }, {
    key: "totalQuestion",
    get: function get() {
      return this.props.totalQuestion;
    }
  }, {
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "previousSectionId",
    get: function get() {
      return this.props.previousSectionId;
    }
  }, {
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "updateTotalScore",
    value: function updateTotalScore(score) {
      this.props.totalScore = score;
      return Result.ok();
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      this.props.title = title;
      return Result.ok();
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(index) {
      this.props.index = index;
      return Result.ok();
    }
  }, {
    key: "updatePreviousSectionId",
    value: function updatePreviousSectionId(previousSectionId) {
      this.props.previousSectionId = previousSectionId;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var _this$audioFile;

      return _objectSpread(_objectSpread({}, this.props), {}, {
        audioFile: (_this$audioFile = this.audioFile) === null || _this$audioFile === void 0 ? void 0 : _this$audioFile.toJsonObject()
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new SectionSummary(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "cloneTo",
    value: function cloneTo(props) {
      var clonedSection = SectionSummary.create({
        id: props.id.toString(),
        formId: props.formId,
        title: props.title,
        index: props.index,
        totalScore: props.totalScore,
        description: props.description,
        previousSectionId: props.previousSectionId,
        totalQuestion: props.totalQuestion,
        audioFile: props.audioFile
      });
      return clonedSection.getValue();
    }
  }, {
    key: "createFromSection",
    value: function createFromSection(section) {
      return SectionSummary.create({
        id: section.id.toString(),
        formId: section.formId,
        title: section.title,
        totalScore: 0,
        description: section.description,
        previousSectionId: section.previousSectionId,
        totalQuestion: 0,
        audioFile: section.audioFile
      }).getValue();
    }
  }, {
    key: "cloneFromSectionAndQuestions",
    value: function cloneFromSectionAndQuestions(section, questions) {
      var questionsBelongToSection = questions.filter(function (question) {
        return question.sectionId === section.id.toString();
      });
      var totalScore = Questions.getTotalScore(questionsBelongToSection);
      var totalQuestion = Questions.getTotalQuestions(questionsBelongToSection);
      return SectionSummary.create({
        id: section.id.toString(),
        formId: section.formId,
        title: section.title,
        description: section.description,
        previousSectionId: section.previousSectionId,
        index: section.index,
        totalScore: totalScore,
        totalQuestion: totalQuestion,
        audioFile: section.audioFile
      }).getValue();
    }
  }]);

  return SectionSummary;
}(Entity);